import axios from "axios";

export const productsHttp = axios.create({
  baseURL: process.env.REACT_APP_API_PRODUCTS_URL,
  timeout: 600000,
  maxRedirects: 10,
});